import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { DashboardScope } from "@/features/dashboard/types.ts";

interface DashboardScopeState {
	scope: DashboardScope;
	setScope: (scope: DashboardScope) => void;
}

export const useDashboardScope = create<DashboardScopeState>()(
	persist(
		(set) => ({
			scope: "obra",
			setScope: (scope) => set({ scope }),
		}),
		{
			name: "otd-dashboard-scope",
			storage: createJSONStorage(() => sessionStorage),
		},
	),
);
